module.exports = __webpack_public_path__ + "img/DSC_1160.d081bd48.jpg";